// Legacy QUO tokens — still referenced by Markdown / Footer / Indicator.
// Kept stable to avoid touching every call-site while migrating to the
// new Moon design tokens below.
export const QUO_BLUE = '#3f44bf';
export const QUO_BLUE_50 = '#9498ff';

export const QUO_POWER = '#d46944';
export const QUO_POWER_75 = '#df8d71';

// ── New PDF design system (mirrors `styles/globals/tokens/colors.css`) ──
// Used by the redesigned header, metadata box, modules, chips and footer.

export const PDF_FONT_FAMILY = 'Inter';

export const PDF_COLORS = {
  // Surface / structure
  pageBackground: '#ffffff',
  cardSurface: '#ffffff',
  borderLine: '#d8dbe8',

  // Text
  textPrimary: '#1f2033',
  textSecondary: '#45454d',
  textMuted: '#919299',
  textOnDark: '#ffffff',

  // Brand
  brandSymbol: '#d46944', // QuoIntelligence orange "M"
  brandAccent: '#d46944', // "ACT BEFORE IT MOVES." pill
  brandAccentText: '#ffffff',
  brandTagline: '#1f2033', // "KNOW YOUR RISK." text

  // Metadata blocks (two separate panels, navy with chip badges in two
  // different tints depending on the row).
  metadataBoxBg: '#3c5092',
  metadataLabel: '#ffffff',
  metadataChipBgPrimary: '#1f3d84', // ID / Relevant to row
  metadataChipBgSecondary: '#4e5f9c', // Type / Locations / Industries row
  metadataChipText: '#ffffff',

  // Entity chips (bottom summary panel)
  entityPanelBg: '#ebebfa',
  entityChipBg: '#ffffff',
  entityChipText: '#1f2033',
  entityLabel: '#1f2033',

  // IoC block
  iocPanelBg: '#f2f4f8',
  iocText: '#1f2033',

  // Report footer (consolidated Threat Information / ATT&CK / IoC panel).
  // The chip-style EntityChips block reuses the same tokens for visual unity.
  // Headers and labels stay in the regular dark body color; chip text, table
  // cells and IoC entries use the navy accent.
  footerPanelBg: '#f1f2f3',
  footerDivider: '#ffffff',
  footerHeader: '#1f2033',
  footerLabel: '#1f2033',
  footerAccent: '#44509e',
  footerChipBg: '#e2e5ec',
  footerChipText: '#44509e',

  // Image placeholder background
  imageFrameBg: '#ebeff2',

  // Links / accents
  link: '#3f44bf',
  bulletSquare: '#d46944',
} as const;
